class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);

// let goKwikCheckoutButton = document.querySelectorAll(
//   ".gokwik-checkout .btn-text span:first-child"
// );
// if (goKwikCheckoutButton) {
//   goKwikCheckoutButton.forEach((button) => {
//     button.innerHTML = "CheckOut";
//   });
// }

let cartTotalPrice;
let snapRupee = document.querySelector(".dp-class");
let payNowPrice = document.querySelector(".pay-now-price");

class CartAddButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const variantId = this.getAttribute("data-variant-id");
      if (!variantId) {
        console.error("Variant ID is missing");
        return;
      }
      const spinner = this.querySelector(".cart-loading-spinner");
      const content = this.querySelector(".cart-button-content");

      if (spinner && content) {
        spinner.classList.remove("hidden");
        content.classList.add("hidden");
      }
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((response) => {
          if (!response.ok) {
            return response.text().then((text) => {
              throw new Error(text);
            });
          }
          return response.json();
        })
        .then(() => {
          this.updateCartHtml();
          reinitializeCarousels();
          event.preventDefault();

          if (spinner && content) {
            spinner.classList.add("hidden");
            content.classList.remove("hidden");
          }
        })
        .catch((error) => console.error("Cart add error:", error));
    });
  }

  async updateCartHtml() {
    console.log("CartAddButton.updateCartHtml called");
    try {
      const response = await fetch("/cart");
      const cartHtml = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(cartHtml, "text/html");
      const cartContainer = doc.querySelector(".cart_main__container");
      const cartItemsContainer = doc.querySelector("#main-cart-items");
      const totalsCartFooterContainer = doc.querySelector(
        ".cart__policy_with--footer"
      );
      const itemsCount = doc.querySelector(".cart-count-bubble").innerHTML;
      const cartFooterTotals = doc.querySelector(
        ".cart__total--value"
      ).innerHTML;
      const countOnCartHeading = document.querySelector(
        ".cart__items--heading sup"
      );
      const cartFooterMobileTotals = document.querySelector(
        ".cart__total--price.cart_total"
      );

      if (cartFooterMobileTotals) {
        cartFooterMobileTotals.innerHTML = cartFooterTotals;
      }
      if (itemsCount && countOnCartHeading) {
        countOnCartHeading.innerHTML = `(${itemsCount})`;
      }
      if (cartContainer) {
        console.log("CartAddButton: Updating cart HTML");
        const existingCartItemsContainer =
          document.querySelector("#main-cart-items");
        const existingTotalsCartFooterContainer = document.querySelector(
          ".cart__policy_with--footer"
        );
        if (existingCartItemsContainer) {
          existingCartItemsContainer.innerHTML = cartItemsContainer.innerHTML;
        }
        if (existingTotalsCartFooterContainer) {
          existingTotalsCartFooterContainer.innerHTML =
            totalsCartFooterContainer.innerHTML;
        }
      }

      const cartDataResponse = await fetch("/cart.js");
      const cartData = await cartDataResponse.json();
      // console.log('Cart data:', cartData);
      cartTotalPrice =
        Number(cartData.total_price.toString().replace(/00$/, "") * 33.33) /
        100;
      snapRupee.innerHTML = Math.round(cartTotalPrice);
      payNowPrice.innerHTML = `₹ ${Math.round(cartTotalPrice)}`;

      // Reinitialize scroll functionality after cart HTML is updated
      setTimeout(() => {
        if (typeof initializeScrollFunctionality === "function") {
          initializeScrollFunctionality();
        }
      }, 100); // Small delay to ensure DOM is fully updated
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  }
}

customElements.define("cart-add-button", CartAddButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        // Pass the event to onCartUpdate so it can check the source
        this.onCartUpdate(event);
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate(event) {
    console.log("CartItems.onCartUpdate called");

    // Skip update if this event was triggered by cart-items itself
    // This prevents double rendering when updateQuantity already updated the DOM
    if (event && event.source === "cart-items") {
      console.log(
        "Skipping onCartUpdate because it was triggered by cart-items"
      );

      // Still initialize scroll functionality
      setTimeout(() => {
        if (typeof initializeScrollFunctionality === "function") {
          initializeScrollFunctionality();
        }
      }, 100);

      return;
    }

    if (this.tagName === "CART-DRAWER-ITEMS") {
      console.log("Updating cart drawer");
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              console.log(`Replacing ${selector}`);
              targetElement.replaceWith(sourceElement);
            }
          }

          // Reinitialize scroll functionality after cart drawer is updated
          setTimeout(() => {
            if (typeof initializeScrollFunctionality === "function") {
              initializeScrollFunctionality();
            }
          }, 100);
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      console.log("Updating main cart items");
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          console.log("Replacing cart-items innerHTML");
          this.innerHTML = sourceQty.innerHTML;

          // Reinitialize scroll functionality after cart items are updated
          setTimeout(() => {
            if (typeof initializeScrollFunctionality === "function") {
              initializeScrollFunctionality();
            }
          }, 100);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: "#main-cart-items",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "cart__policy_with--footer",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".cart__policy_with--footer",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    console.log(
      `CartItems.updateQuantity called: line=${line}, quantity=${quantity}`
    );
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    console.log("Sending cart change request to Shopify API");
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        console.log("Cart change API response received");
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");

        if (parsedState.errors) {
          console.log("Cart update errors:", parsedState.errors);
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        // console.log(this);
        let cartMainContainerQtyZero = document.querySelector(
          ".page-width.cart_main__container"
        );
        let mainCartWhenEmpty = document.querySelector(".main-cart");
        if (cartMainContainerQtyZero) {
          cartMainContainerQtyZero.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );
        }

        if (mainCartWhenEmpty) {
          mainCartWhenEmpty.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );
        }
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        console.log("Updating cart sections from API response");
        this.getSectionsToRender().forEach((section) => {
          console.log(`Updating section: ${section.id}`);
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          let itemCountOnChange =
            document.querySelector(".cart-count-bubble").innerHTML;
          let cartHeadingItemCountOnChange = document.querySelector(
            ".cart__items--heading sup"
          );
          if (itemCountOnChange && cartHeadingItemCountOnChange) {
            cartHeadingItemCountOnChange.innerHTML = `(${itemCountOnChange.trim()})`;
          }
          let subTotalOnChange = document.querySelector(
            ".cart__total--value"
          ).innerHTML;
          let subTotalGoKwik = document.querySelector(
            ".cart__total--price.cart_total"
          );

          if (subTotalGoKwik && subTotalOnChange) {
            subTotalGoKwik.innerHTML = subTotalOnChange;
          }

          let priceOnChange = document
            .querySelector(".cart__total--value")
            .innerHTML.trim()
            .replace(/^[^\d.-]+/, "")
            .replace(/,/g, "");

          cartTotalPrice = parseFloat(priceOnChange * 33.33) / 100;
          console.log(priceOnChange / 3);
          document.querySelector(".dp-class").innerHTML =
            Math.round(cartTotalPrice);
          document.querySelector(".pay-now-price").innerHTML =
            Math.round(cartTotalPrice);
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        console.log("Calling updateLiveRegions");
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        console.log("Publishing cartUpdate event");
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    console.log("CartItems.updateLiveRegions called for line:", line);
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);

    // We no longer need to fetch and update the cart HTML here
    // because it's already been updated by updateQuantity

    // Update price calculations if needed
    try {
      const priceElement = document.querySelector(".cart__total--value");
      if (priceElement) {
        const priceOnChange = priceElement.innerHTML
          .trim()
          .replace(/^[^\d.-]+/, "")
          .replace(/,/g, "");

        cartTotalPrice = parseFloat(priceOnChange * 33.33) / 100;

        const dpClass = document.querySelector(".dp-class");
        const payNowPrice = document.querySelector(".pay-now-price");

        if (dpClass) dpClass.innerHTML = Math.round(cartTotalPrice);
        if (payNowPrice)
          payNowPrice.innerHTML = `₹ ${Math.round(cartTotalPrice)}`;
      }
    } catch (error) {
      console.error("Error updating price calculations:", error);
    }

    // Initialize scroll functionality
    setTimeout(() => {
      if (typeof initializeScrollFunctionality === "function") {
        initializeScrollFunctionality();
      }
    }, 100);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

// Function to initialize scroll functionality
function initializeScrollFunctionality() {
  const linkBillSummary = document.querySelector(
    ".go-kwik-widget .cart__footer--details__link"
  );
  const targetBillSummary = document.querySelector("#order-summary-scroll");

  if (linkBillSummary && targetBillSummary) {
    // Remove any existing event listeners to prevent duplicates
    const newLinkBillSummary = linkBillSummary.cloneNode(true);
    linkBillSummary.parentNode.replaceChild(
      newLinkBillSummary,
      linkBillSummary
    );

    // Add the event listener to the new element
    newLinkBillSummary.addEventListener("click", function (e) {
      e.preventDefault();

      // Scroll to element's position relative to page, minus 80px for offset
      const scrollTargetY =
        window.scrollY + targetBillSummary.getBoundingClientRect().top - 80;

      gsap.to(window, {
        scrollTo: {
          y: scrollTargetY,
          autoKill: false,
        },
        duration: 0.5,
        ease: "expo.out",
        snap: 1,
      });
    });
    console.log("Scroll functionality initialized");
  } else {
    console.error("Link or target element not found for scroll functionality.");
  }
}

// Initialize on DOM content loaded
document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollToPlugin);
  initializeScrollFunctionality();
});
